export const liffId = process.env.REACT_APP_LIFF_ID;
export const endPoint = process.env.REACT_APP_END_POINT;
export const authEndPoint = process.env.REACT_APP_AUTH;